export default function getSleepTime(startTimeEpochMs: number, preProseccing?: boolean) {
    const requiredStartTime = preProseccing ? startTimeEpochMs - 10000 : startTimeEpochMs;
    const timeNow = Date.now();

    return requiredStartTime > timeNow ? requiredStartTime - timeNow : 0;
}
